var map = {
	"./green-button.json": 98,
	"./green-button@2x.json": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite ^\.\/green\-button.*\.json$
// module id = 124
// module chunks = d-game